import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function ViewerCounter() {
  const getRandomViewers = () => Math.floor(Math.random() * (25 - 8 + 1)) + 8;
  const [viewers, setViewers] = useState(getRandomViewers);
  useEffect(() => {
    const update = () => {
      const delay = Math.floor(Math.random() * 5000) + 5000; // 5–10 seconds
      return setTimeout(() => {
        setViewers(getRandomViewers());
      }, delay);
    };
    let timeout = update();
    const loop = setInterval(() => {
      clearTimeout(timeout);
      timeout = update();
    }, 10000);
    return () => {
      clearTimeout(timeout);
      clearInterval(loop);
    };
  }, []);
  return <div className="mb-4 text-center md:text-left" data-id="element-317">
      <AnimatePresence mode="wait" data-id="element-318">
        <motion.p key={viewers} initial={{
        opacity: 0,
        y: 4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -4
      }} transition={{
        duration: 0.3
      }} className="text-sm font-[600] text-[#142805]" data-id="element-319">
          👀 {viewers} personas están viendo esto ahora
        </motion.p>
      </AnimatePresence>
    </div>;
}